import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAccessSessionApi } from "../../hooks";
import { AccessSessionsApiResetAccessSessionCredentialsRequest } from "../../api/v1";
import { GET_ACCESS_SESSION_QUERY_KEY } from "../../hooks/access-sessions/query-keys";

export default function useResetAccessSessionCredentials({
  id,
}: AccessSessionsApiResetAccessSessionCredentialsRequest) {
  const api = useAccessSessionApi();
  const queryClient = useQueryClient();

  const fetchMethod = async () => {
    const result = await api.resetAccessSessionCredentials({ id });
    return result;
  };

  const {
    mutate: resetAccessSessionCredentials,
    mutateAsync: resetAccessSessionCredentialsAsync,
    ...rest
  } = useMutation(fetchMethod, {
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_ACCESS_SESSION_QUERY_KEY, id],
      }),
  });

  return {
    resetAccessSessionCredentials,
    resetAccessSessionCredentialsAsync,
    ...rest,
  };
}
